module.exports = __webpack_public_path__ + "img/logo-fondo-marino.c685b456.png";